<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ customer.firstName }} {{ customer.lastName }}
            </span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <table>
            <tr>
                <th class="text-left" style="width: 100px;">{{ 'Phone'|translate }}: </th>
                <td style="width: 200px;">{{ customer.phone }}</td>
            </tr>
            <tr>
                <th class="text-left" style="width: 100px;">{{ 'Email'|translate }}: </th>
                <td>{{ customer.email }}</td>
            </tr>
            <tr>
                <th class="text-left" style="width: 100px;">{{ 'Description'|translate }}: </th>
                <td class="text-right">
                    <a (click)="editCustomerDescription(customer)" style="cursor: pointer;">
                        {{ 'Edit description'|translate }}
                    </a>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <span *ngIf="customer.description === undefined || customer.description.length === 0">{{'description not provided'|translate}}</span>
                    {{customer.description}}
                </td>
            </tr>
        </table>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

    </div>
</div>
